export default __webpack_public_path__ + "static/media/img15.80d332bc.jpg";